import {produce} from 'immer';
import {useMutation} from '@apollo/client';

import {updateApolloCache} from 'web-app/util/graphql';

import {SetAutomaticInvoicingConfig, FetchAutomaticInvoicingConfig} from '../queries';
import {
    type FetchAutomaticInvoicingConfigQuery,
    type FetchAutomaticInvoicingConfigQueryVariables,
    type SetAutomaticInvoicingConfigMutation,
    type SetAutomaticInvoicingConfigMutationVariables,
} from '../__generated__/queries.api-types-no-enum';

export const useSetAutomaticInvoicingConfig = (siteSetId: string) => {
    const [setAutomationInvoicingConfig] = useMutation<
        SetAutomaticInvoicingConfigMutation,
        SetAutomaticInvoicingConfigMutationVariables
    >(SetAutomaticInvoicingConfig, {
        update: updateApolloCache<FetchAutomaticInvoicingConfigQuery, FetchAutomaticInvoicingConfigQueryVariables>()({
            type: 'query',
            node: FetchAutomaticInvoicingConfig,
            cacheVariables: {siteSetId},
            updater: (cachedData, result) => {
                if (result.finance.invoices.automaticInvoicing.setAutomaticInvoicingConfig) {
                    return produce(cachedData, draft => {
                        draft.finance.invoices.automaticInvoicing.automaticInvoicingConfig =
                            result.finance.invoices.automaticInvoicing.setAutomaticInvoicingConfig;
                    });
                }
                return cachedData;
            },
        }),
    });

    return {setAutomationInvoicingConfig};
};
